module.exports = __webpack_public_path__ + "img/addfriend.a3b83389.png";